import { Suspense } from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
// import LoanApplicationWrapper from '../modules/loanApplication';

export function PrivateRoutes() {
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Redirect exact from='/' to='/application/type' />

        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
